export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-16">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40 pointer-events-none"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs md:text-sm font-semibold rounded-full mb-5 whitespace-nowrap">
              <i className="ri-android-line mr-1"></i>安卓影视APP
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              91影视看片下载
              <span className="block text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-600 mt-2">手机免费追剧观影平台</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-primary-600 font-medium mb-6">
              随时随地，高清追剧不等待
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              91影视看片下载是专为安卓用户打造的<strong>免费影视APP</strong>，聚合全网海量影视资源，涵盖热门电视剧、最新电影、综艺娱乐、动漫番剧及纪录片等全品类内容。
              看片软件下载后无需注册即可畅享<strong>高清画质</strong>与<strong>极速播放</strong>体验，每日同步更新院线新片与卫视热剧，支持离线缓存、投屏观看与多分辨率切换，
              是您手机追剧看片的<strong>首选免费工具</strong>。当前版本已覆盖超3万部正版片源，日更新量保持200+，持续为影迷提供稳定流畅的观影服务。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">30,000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">高清片源覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每日内容更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-600">永久免费</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">无广告纯净观影</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); scrollTo('#app'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-white text-base font-semibold rounded-xl hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-[0_4px_20px_rgba(200,60,35,0.35)]"
              >
                <i className="ri-download-cloud-2-line text-xl"></i>
                立即下载APP
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); scrollTo('#features'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-background-300 text-foreground-700 text-base font-semibold rounded-xl hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-xl"></i>
                了解特色功能
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[480px] md:w-[320px] md:h-[540px]">
              <div className="absolute -top-4 -left-4 w-24 h-24 md:w-32 md:h-32 bg-accent-200/60 rounded-3xl rotate-12"></div>
              <div className="absolute -bottom-6 -right-6 w-28 h-28 md:w-36 md:h-36 bg-primary-100/60 rounded-full"></div>
              <div className="relative z-10 w-full h-full rounded-3xl overflow-hidden border-4 border-background-200 bg-background-950">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20movie%20streaming%20app%20interface%20with%20Chinese%20film%20posters%20in%20a%20grid%20layout%2C%20dark%20theme%20UI%20with%20warm%20accent%20colors%2C%20clean%20minimal%20design%2C%20cinematic%20atmosphere%2C%20high%20quality%20rendering%2C%20soft%20lighting%20on%20the%20screen%2C%20isolated%20on%20transparent%20background&width=640&height=1080&seq=hero-phone-2026-x1&orientation=portrait"
                  alt="91影视看片APP手机界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}